import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import {
  loggedInUserData, selectDynamicEagerLoadingLeadCatgoriesState$, selectDynamicEagerLoadingSourcesState$, selectStaticEagerLoadingCustomerTypesState$,
  selectStaticEagerLoadingSiteTypesState$, selectStaticEagerLoadingTitlesState$
} from '@app/modules';
import { AppState } from '@app/reducers';
import {
  IApplicationResponse, LeadGroupTypes, LoggedInUserModel, ModulesBasedApiSuffix,
  ResponseMessageTypes, SERVER_REQUEST_DATE_TRANSFORM,
  SnackbarService,
  debounceTimeForSearchkeyword, defaultCountryCode, defaultPopupType, destructureAfrigisObjectAddressComponents, disableFormControls, enableFormControls, formConfigs, getFullFormatedAddress,
  mapConfigurationUtils,
  prepareGetRequestHttpParams, prepareRequiredHttpParams, removeFormControlError,
  setRequiredValidator
} from '@app/shared';
import { CrudService, RxjsService } from '@app/shared/services';
import { RelocationModel } from '@modules/customer';
import { NewAddressPopupComponent, SalesModuleApiSuffixModels } from '@modules/sales';
import { Store } from '@ngrx/store';
import { Observable, combineLatest, forkJoin, of } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
@Component({
  selector: 'app-relocation',
  templateUrl: './relocation.component.html',
  styleUrls: ['./relocation.component.scss']
})
export class RelocationComponent implements OnInit {
  formConfigs = formConfigs;
  relocationForm: FormGroup;
  serviceCategories = [];
  installedSystem = [];
  @Input() customerInfo;
  installedSystemForRelocated = [];
  currentAddresses;
  customerId = "";
  currentAddressItems = [];
  oldAddressItems = [];
  addressId;
  loggedInUserData: LoggedInUserModel;
  titles;
  customerTypes;
  siteTypes;
  leadCategories;
  sourceTypes;
  customerDetails;
  startTodayDate = new Date();
  isFormSubmitted = false;
  getCustomerData;
  shouldShowLocationPinBtn = false;
  latLongObj;
  isCustomAddressSaved = false;
  getLoopableObjectRequestObservable: Observable<IApplicationResponse>;
  selectedAddressOption;
  selectedCurrentAddressObj;
  selectedRelocatedAddressObj;
  feature: string;
  featureIndex: string;
  stopAndKnockDialog = false;
  stopAndKnockDetails: any;
  defaultPopupType = defaultPopupType.P_DIALOG;

  constructor(private crudService: CrudService,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog,
    private rxjsService: RxjsService,
    private router: Router, private datePipe: DatePipe,
    private store: Store<AppState>, private snackbarService: SnackbarService) {
  }

  ngOnInit(): void {
    this.combineLatestNgrxStoreData();
    this.getCustomerCurrentAddresses();
    this.createRelocationForm();
    this.getForkJoinRequests();
    this.onFormControlChanges();
  }

  combineLatestNgrxStoreData() {
    combineLatest([
      this.store.select(loggedInUserData), this.store.select(selectStaticEagerLoadingTitlesState$), this.store.select(selectStaticEagerLoadingSiteTypesState$),
      this.store.select(selectStaticEagerLoadingCustomerTypesState$), this.store.select(selectDynamicEagerLoadingLeadCatgoriesState$),
      this.activatedRoute.queryParams, this.rxjsService.getCustomerDate(), this.store.select(selectDynamicEagerLoadingSourcesState$),])
      .subscribe((response) => {
        this.loggedInUserData = new LoggedInUserModel(response[0]);
        this.titles = response[1];
        this.siteTypes = response[2];
        this.customerTypes = response[3];
        this.leadCategories = response[4];
        this.sourceTypes = response[7];
        this.customerId = response[5]['customerId'];
        if (response[5]['addressId']) {
          this.addressId = response[5]['addressId'];
        }
        if (response[5]['feature_name']) {
          this.feature = response[5]['feature_name'];
        }
        if (response[5]['featureIndex']) {
          this.featureIndex = response[5]['featureIndex'];
        }
        if (response[6]) {
          this.getCustomerData = response[6];
        }
      });
  }

  onFormControlChanges(): void {
    this.onFormatedAddressFormControlValueChanges();
    this.relocationForm.get('isAfrigisSearch').valueChanges.subscribe((isAfrigisSearch: boolean) => {
      this.relocationForm.get('formatedAddress').setValue("");
      if (isAfrigisSearch) {
        this.relocationForm.get('addressId').setValue(this.relocationForm.get('addressId').value ?
          this.relocationForm.get('addressId').value : "");
        this.relocationForm.get('isAddressExtra').setValue(false);
        this.clearAddressFormGroupValues();
      }
    });
    this.relocationForm.get("isAddressComplex").valueChanges.subscribe((isAddressComplex: boolean) => {
      if (!isAddressComplex) {
        this.relocationForm.get("rebuildingNumber").setValue(null);
        this.relocationForm.get("rebuildingName").setValue(null);
      }
    });
    this.relocationForm.get("isAddressExtra").valueChanges.subscribe((isAddressExtra: boolean) => {
      if (isAddressExtra) {
        this.relocationForm = enableFormControls(this.relocationForm, ["estateStreetNo", "estateStreetName", "estateName"]);
      } else {
        this.relocationForm = disableFormControls(this.relocationForm, ["estateStreetNo", "estateStreetName", "estateName"]);
        this.relocationForm.get("estateStreetNo").setValue(null);
        this.relocationForm.get("estateStreetName").setValue(null);
        this.relocationForm.get("estateName").setValue(null);
      }
    });
  }

  onFormatedAddressFormControlValueChanges(): void {
    this.relocationForm
      .get("formatedAddress")
      .valueChanges.pipe(
        debounceTime(debounceTimeForSearchkeyword),
        distinctUntilChanged()).subscribe((searchtext) => {
          if (!searchtext || this.isCustomAddressSaved == true) {
            this.getLoopableObjectRequestObservable = of();
          }
          else {
            this.getLoopableObjectRequestObservable = this.crudService.get(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.SALES_API_UX_ADDRESS, null, true,
              prepareRequiredHttpParams({
                searchtext,
                isAfrigisSearch: this.relocationForm.get("isAfrigisSearch").value
              }));
          }
        });
  }

  openFindPinMap() {
    mapConfigurationUtils(this.rxjsService, this.dialog, 'Two Table Architecture Custom Address', this.latLongObj).afterClosed().subscribe((result) => {
      if (result?.hasOwnProperty('latLong')) {
        this.latLongObj = result.latLong;
        this.relocationForm.get("relocationPin").setValue(`${result.latLong.lat.toFixed(6)}, ${result.latLong.lng.toFixed(4)}`)
      }
      this.rxjsService.setGlobalLoaderProperty(false);
    });
  }

  clearAddressFormGroupValues(): void {
    this.relocationForm.patchValue({
      relocationPin: null,
      resuburb: null, recity: null,
      reprovince: null, repostalCode: null,
      restreetAddress: null, restreetNumber: null,
      rebuildingName: null, rebuildingNumber: null,
      estateName: null, estateStreetNo: null,
      estateStreetName: null, addressConfidentLevelName: null
    });
  }

  onSelectedItemOption(selectedObject): void {
    if (!selectedObject) return;
    this.selectedAddressOption = selectedObject;
    if (this.relocationForm.get('isAfrigisSearch').value) {
      this.relocationForm.get("seoId").setValue(selectedObject["seoid"]);
      this.getAddressFullDetails(selectedObject["seoid"]);
      this.relocationForm.get('addressId').setValue(this.relocationForm.get('addressId').value ? this.relocationForm.get('addressId').value : null);
    } else {
      // Check for stop and knock address when afrigis search is not selected
      if (selectedObject['addressId']) {
        //this.checkStopAndKnockAddress(selectedObject['addressId']);
      }

      selectedObject["longitude"] = selectedObject["longitude"] ? selectedObject["longitude"] : "";
      selectedObject["latitude"] = selectedObject["latitude"] ? selectedObject["latitude"] : "";
      if (selectedObject["latitude"] && selectedObject["longitude"]) {
        selectedObject["latLong"] = `${selectedObject["latitude"]}, ${selectedObject["longitude"]}`;
      } else {
        selectedObject["latLong"] = "";
      }
      this.relocationForm.patchValue(
        {
          addressId: selectedObject['addressId'],
          seoId: "",
          latitude: selectedObject["latitude"],
          longitude: selectedObject["longitude"],
          relocationPin: selectedObject["latLong"],
          resuburb: selectedObject["suburbName"],
          recity: selectedObject["cityName"],
          reprovince: selectedObject["provinceName"],
          repostalCode: selectedObject["postalCode"],
          restreetAddress: selectedObject["streetName"],
          restreetNumber: selectedObject["streetNo"],
          estateName: selectedObject["estateName"],
          estateStreetName: selectedObject["estateStreetName"],
          estateStreetNo: selectedObject["estateStreetNo"],
          rebuildingName: selectedObject["buildingName"],
          rebuildingNo: selectedObject["buildingNo"],
          addressConfidentLevelName: selectedObject["addressConfidentLevelName"],
          addressConfidentLevelId: selectedObject["addressConfidentLevelId"]
        }, { emitEvent: false, onlySelf: true });
    }
    this.relocationForm.get('relocationPin').markAllAsTouched();
    this.relocationForm.get('relocationPin').updateValueAndValidity();
  }

  getAddressFullDetails(seoid: string): void {
    this.crudService.get(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.SALES_API_ADDRESS_DETAILS,
      undefined, false, prepareRequiredHttpParams({ seoid }))
      .subscribe((response: IApplicationResponse) => {
        if (response.isSuccess && response.statusCode === 200 && response.resources) {
          this.relocationForm.get("addressConfidentLevelName").setValue(response.resources.addressConfidenceLevel);
          response.resources.addressDetails.forEach((addressObj) => {
            this.relocationForm.get("addressConfidentLevelId").setValue(addressObj.confidence);
            this.patchAddressFormGroupValues(addressObj, addressObj["address_components"]);
          });
          this.relocationForm.updateValueAndValidity();
        }
        this.rxjsService.setGlobalLoaderProperty(false);
      });
  }

  patchAddressFormGroupValues(addressObj, addressComponents: Object[]) {
    addressObj.geometry.location.lat = addressObj.geometry.location.lat
      ? addressObj.geometry.location.lat : "";
    addressObj.geometry.location.lng = addressObj.geometry.location.lng
      ? addressObj.geometry.location.lng : "";
    if (addressObj.geometry.location.lat && addressObj.geometry.location.lng) {
      addressObj.geometry.location.latLong = `${addressObj.geometry.location.lat}, ${addressObj.geometry.location.lng}`;
    } else {
      addressObj.geometry.location.latLong = "";
    }
    let destructureAfrigisObjectAddressComponentsObj: any = destructureAfrigisObjectAddressComponents(addressComponents);
    destructureAfrigisObjectAddressComponentsObj.latitude = addressObj.geometry.location.lat;
    destructureAfrigisObjectAddressComponentsObj.longitude = addressObj.geometry.location.lng;
    destructureAfrigisObjectAddressComponentsObj.relocationPin = addressObj.geometry.location.latLong;
    destructureAfrigisObjectAddressComponentsObj.addressConfidentLevelId = addressObj.confidence;
    this.selectedRelocatedAddressObj = destructureAfrigisObjectAddressComponentsObj;
    this.relocationForm.patchValue(
      {
        latitude: destructureAfrigisObjectAddressComponentsObj.latitude,
        longitude: destructureAfrigisObjectAddressComponentsObj.longitude,
        relocationPin: destructureAfrigisObjectAddressComponentsObj.relocationPin,
        rebuildingName: destructureAfrigisObjectAddressComponentsObj.buildingName,
        rebuildingNumber: destructureAfrigisObjectAddressComponentsObj.buildingNo,
        estateName: destructureAfrigisObjectAddressComponentsObj.estateName,
        estateStreetName: destructureAfrigisObjectAddressComponentsObj.estateStreetName,
        estateStreetNo: destructureAfrigisObjectAddressComponentsObj.estateStreetNo,
        resuburb: destructureAfrigisObjectAddressComponentsObj.suburbName,
        recity: destructureAfrigisObjectAddressComponentsObj.cityName,
        reprovince: destructureAfrigisObjectAddressComponentsObj.provinceName,
        repostalCode: destructureAfrigisObjectAddressComponentsObj.postalCode,
        restreetAddress: destructureAfrigisObjectAddressComponentsObj.streetName,
        restreetNumber: destructureAfrigisObjectAddressComponentsObj.streetNo,
      },
      { emitEvent: false, onlySelf: true }
    );
  }

  getForkJoinRequests(): void {
    forkJoin([this.getCustomerCurrentAddresses()])
      .subscribe((response: IApplicationResponse[]) => {
        response.forEach((respObj: IApplicationResponse, ix: number) => {
          if (respObj.isSuccess && respObj.statusCode == 200 && respObj.resources) {
            switch (ix) {
              case 0:
                this.currentAddresses = respObj.resources;
                this.getCustomerDetailsById();
                break;
            }
          }
        });
      });
  }

  getCustomerDetailsById() {
    this.crudService.get(ModulesBasedApiSuffix.CUSTOMER_MANAGEMENT,
      SalesModuleApiSuffixModels.GET_CUSTOMER_BY_ID, this.customerId, false, null).subscribe((response: IApplicationResponse) => {
        if (response.resources && response.statusCode == 200 && response.isSuccess) {
          this.customerDetails = response.resources;
          let customerDetails = JSON.parse(JSON.stringify(response.resources));
          if (this.customerDetails) {
            this.customerDetails.mobile1 = this.customerDetails.mobileNumber1.split(' ')[1];
            this.customerDetails.mobile1CountryCode = this.customerDetails.mobileNumber1.split(' ')[0];
            if (this.customerDetails.mobileNumber2) {
              this.customerDetails.mobile2 = this.customerDetails.mobileNumber2.split(' ')[1];
              this.customerDetails.mobile2CountryCode = this.customerDetails.mobileNumber2.split(' ')[0];
            }
            else {
              this.customerDetails.mobile2 = "";
              this.customerDetails.mobile2CountryCode = defaultCountryCode;
            }
            if (customerDetails.officeNo) {
              this.customerDetails.officeNo = customerDetails.officeNo.split(' ')[1];
              this.customerDetails.officeNoCountryCode = customerDetails.officeNo.split(' ')[0];
            }
            else {
              this.customerDetails.officeNo = "";
              this.customerDetails.officeNoCountryCode = defaultCountryCode;
            }
            if (customerDetails.premisesNo) {
              this.customerDetails.premisesNo = customerDetails.premisesNo.split(' ')[1];
              this.customerDetails.premisesNoCountryCode = customerDetails.premisesNo.split(' ')[0];
            }
            else {
              this.customerDetails.premisesNo = "";
              this.customerDetails.premisesNoCountryCode = defaultCountryCode;
            }
          }
        }
        this.rxjsService.setGlobalLoaderProperty(false);
      });
  }

  getCustomerCurrentAddresses() {
    return this.crudService.get(ModulesBasedApiSuffix.CUSTOMER_MANAGEMENT,
      SalesModuleApiSuffixModels.CURRENT_ADDRESS_INFO, undefined, false, prepareRequiredHttpParams({
        customerId: this.customerId,
        addressId: this.addressId
      }))
  }

  selectedAddress() {
    this.selectedCurrentAddressObj = null;
    let formValue = this.relocationForm.getRawValue();
    this.addressId = formValue.currentAddressId;
    let selectedAddress = this.currentAddresses.find(e => e.addressId == this.addressId);
    let selectedleadCategories = [];
    if (selectedAddress.leadCategories) {
      selectedAddress?.leadCategories?.split(",")?.forEach(results => {
        selectedleadCategories.push(this.leadCategories.find(element => element.id == results));
      })
      selectedAddress.leadCategoryId = selectedleadCategories;
    }
    selectedAddress.locationPin = selectedAddress.longitude + " " + selectedAddress.latitude;
    selectedAddress.buildingNumber = selectedAddress.buildingNo;
    this.relocationForm.patchValue(selectedAddress);
    if (selectedAddress.installedSystems && selectedAddress.installedSystems.length > 0) {
      this.installedSystem = selectedAddress.installedSystems;
    }
    if (selectedAddress.activeSubscriptions && selectedAddress.activeSubscriptions.length > 0) {
      this.serviceCategories = selectedAddress.activeSubscriptions;
    }
    this.selectedCurrentAddressObj = selectedAddress;
  }

  getInstalledSystemInfo(addressId) {
    this.crudService.get(ModulesBasedApiSuffix.CUSTOMER_MANAGEMENT,
      SalesModuleApiSuffixModels.GET_INSTALLED_SYSTEM,
      undefined,
      false, prepareGetRequestHttpParams(null, null, { addressId })).subscribe((response: IApplicationResponse) => {
        if (response.resources && response.statusCode == 200 && response.isSuccess) {
          this.installedSystemForRelocated = response.resources;
          if (this.installedSystemForRelocated && this.installedSystemForRelocated.length > 0) {
            this.installedSystemForRelocated.forEach(element => {
              element.installedItems.forEach((obj, i) => {
                let dt = {
                  itemId: ''
                }
                dt.itemId = obj;
                element.installedItems[i] = dt;
              });
            });
          }
        }
        this.rxjsService.setGlobalLoaderProperty(false);
      });
  }

  openAddressPopup(): void {
    this.relocationForm.value.createdUserId = this.loggedInUserData.userId;
    this.relocationForm.value.modifiedUserId = this.loggedInUserData.userId;
    let leadForm = { ...this.relocationForm.value, ...this.relocationForm.getRawValue() };
    leadForm.contactInfo = this.customerDetails;
    leadForm = { ...leadForm, ...this.getCustomerData };
    const dialogReff = this.dialog.open(NewAddressPopupComponent, {
      width: "750px",
      disableClose: true,
      data: leadForm,
    });
    dialogReff.afterClosed().subscribe((result) => {
      if (result) {
        this.isCustomAddressSaved = false;
      }
    });
    dialogReff.componentInstance.outputData.subscribe((result) => {
      if (result) {
        this.isCustomAddressSaved = true;
        this.shouldShowLocationPinBtn = result.isAddressType == false ? true : false;
        this.relocationForm.patchValue({
          formatedAddress: getFullFormatedAddress(result),
          addressConfidentLevelId: result.addressConfidentLevelId,
          rebuildingName: result.buildingName,
          rebuildingNumber: result.buildingNo,
          estateName: result.estateName,
          estateStreetName: result.estateStreetName,
          estateStreetNo: result.estateStreetNo,
          resuburb: result.suburbName,
          recity: result.cityName,
          reprovince: result.provinceName,
          repostalCode: result.postalCode,
          restreetAddress: result.streetName,
          restreetNumber: result.streetNo
        });
        this.rxjsService.setFormChangeDetectionProperty(true);
      }
      else {
        this.isCustomAddressSaved = false;
      }
    });
  }

  createRelocationForm() {
    let relocationModel = new RelocationModel();
    this.relocationForm = this.formBuilder.group({});
    Object.keys(relocationModel).forEach((key) => {
      this.relocationForm.addControl(key, new FormControl(relocationModel[key]));
    });
    this.relocationForm = setRequiredValidator(this.relocationForm, ["currentAddressId", "formatedAddress", "transferDate", "movingDate", "relocationPin", "leadCategoryId", "siteTypeId", "sourceId"]);
    this.relocationForm = disableFormControls(this.relocationForm, ['estateStreetNo', 'estateStreetName', 'estateName', 'addressConfidentLevelName']);
  }

  checked(value, obj, event) {
    let checkedObj = obj;
    if (value) {
      if (event.checked) {
        if (checkedObj.items.length > 0) {
          checkedObj.items.forEach(element => {
            element.isWillingToTransferCurrentAddressItem = true;
            element.isWillingToUseRelocationAddressItem = false;
          });
        }
        this.currentAddressItems.push(checkedObj);
      } else {
        const index = this.currentAddressItems.findIndex(e => e.systemType == checkedObj.systemType);//Find the index of stored id
        this.currentAddressItems.splice(index, 1);
      }
    } else {
      if (event.checked) {
        if (checkedObj.installedItems && checkedObj.installedItems.length > 0) {
          checkedObj.installedItems.forEach((element, i) => {
            element.isWillingToTransferCurrentAddressItem = false;
            element.isWillingToUseRelocationAddressItem = true;
          });
        }
        checkedObj.items = checkedObj.installedItems;
        this.oldAddressItems.push(checkedObj);
      } else {
        const index = this.oldAddressItems.findIndex(e => e.systemTypeName == checkedObj.systemTypeName);//Find the index of stored id
        this.oldAddressItems.splice(index, 1);
      }
    }
  }

  cancel() {
    this.rxjsService.setRelocation(false);
  }

  validateAtleastOneFieldToBeMandatory(): void {
    if ((this.relocationForm.get("isAddressComplex").value && !this.relocationForm.get("rebuildingNumber").value &&
      !this.relocationForm.get("rebuildingName").value) ||
      (this.relocationForm.get("isAddressExtra").value && !this.relocationForm.get("estateName").value &&
        !this.relocationForm.get("estateStreetName").value && !this.relocationForm.get("estateStreetNo").value)) {
      this.setAtleastOneFieldRequiredError();
    }
    else {
      this.relocationForm = removeFormControlError(this.relocationForm, "atleastOneOfTheFieldsIsRequired");
    }
  }

  setAtleastOneFieldRequiredError() {
    if (this.relocationForm.get("isAddressComplex").value) {
      this.relocationForm.get("rebuildingNumber").setErrors({ atleastOneOfTheFieldsIsRequired: true });
      this.relocationForm.get("rebuildingName").setErrors({ atleastOneOfTheFieldsIsRequired: true });
    }
    if (this.relocationForm.get("isAddressExtra").value) {
      this.relocationForm.get("estateName").setErrors({ atleastOneOfTheFieldsIsRequired: true });
      this.relocationForm.get("estateStreetNo").setErrors({ atleastOneOfTheFieldsIsRequired: true });
      this.relocationForm.get("estateStreetName").setErrors({ atleastOneOfTheFieldsIsRequired: true });
    }
  }

  onSubmit() {
    if (this.relocationForm.invalid) {
      return;
    }
    if (!this.relocationForm.value.recity ||
      !this.relocationForm.value.reprovince) {
      this.snackbarService.openSnackbar("Province Name / City Name is required..!!", ResponseMessageTypes.ERROR);
      return;
    }
    let reqObj: any;
    if (this.relocationForm.get('isAfrigisSearch').value) {
      reqObj = {
        buildingNo: this.relocationForm.getRawValue().rebuildingNo ? this.relocationForm.getRawValue().rebuildingNo : "",
        buildingName: this.relocationForm.getRawValue().rebuildingName ? this.relocationForm.getRawValue().rebuildingName : "",
        streetName: this.relocationForm.getRawValue().estateStreetName ? this.relocationForm.getRawValue().estateStreetName : "",
        streetNo: this.relocationForm.getRawValue().estateStreetNo ? this.relocationForm.getRawValue().estateStreetNo : "",
        suburbName: this.relocationForm.getRawValue().resuburb ? this.relocationForm.getRawValue().resuburb : "",
        cityName: this.relocationForm.getRawValue().recity ? this.relocationForm.getRawValue().recity : "",
        provinceName: this.relocationForm.getRawValue().reprovince ? this.relocationForm.getRawValue().reprovince : "",
        postalCode: this.relocationForm.getRawValue().repostalCode ? this.relocationForm.getRawValue().repostalCode : ""
      }
    }
    else {
      reqObj = this.relocationForm.getRawValue().addressId;
    }
    this.checkStopAndKnockAddress(reqObj);
  }

  onCreateRelocationLead() {
    this.isFormSubmitted = true;
    this.validateAtleastOneFieldToBeMandatory();
    if (this.relocationForm.invalid) {
      return;
    }
    if (!this.relocationForm.value.recity ||
      !this.relocationForm.value.reprovince) {
      this.snackbarService.openSnackbar("Province Name / City Name is required..!!", ResponseMessageTypes.ERROR);
      return;
    }
    let detailObj = this.relocationForm.getRawValue();
    let location = detailObj.relocationPin;
    location = location.split(",");
    let installedArray = this.currentAddressItems.concat(this.oldAddressItems);
    let mergedArray = [];
    installedArray.forEach(element => {
      element.items.forEach(obj => {
        mergedArray.push(obj);
      });
    });
    let selectedleadCategoryId = [];
    this.relocationForm.get('leadCategoryId')?.value?.forEach(result => { selectedleadCategoryId.push(result?.id) })
    let payload = {
      customerId: this.customerId,
      currentAddressId: detailObj.currentAddressId,
      transferDate: this.datePipe.transform(detailObj.transferDate, SERVER_REQUEST_DATE_TRANSFORM),
      reason: detailObj.reason,
      movingDate: this.datePipe.transform(detailObj.movingDate, SERVER_REQUEST_DATE_TRANSFORM),
      createdUserId: this.loggedInUserData.userId,
      titleId: detailObj.titleId,
      firstName: detailObj.firstName,
      lastName: detailObj.lastName,
      companyName: detailObj.companyName,
      companyRegNo: detailObj.companyRegNo,
      said: detailObj.said,
      sourceId: detailObj.sourceId,
      leadGroupId: LeadGroupTypes.RELOCATION,
      customerTypeId: detailObj.customerTypeId,
      contactId: detailObj.contactId,
      siteTypeId: detailObj.siteTypeId,
      leadCategoryId: selectedleadCategoryId,
      addressInfo: !this.relocationForm.get('isAfrigisSearch').value ? this.selectedAddressOption : this.selectedRelocatedAddressObj,
      relocationItems: mergedArray
    }
    payload.addressInfo.buildingName = this.relocationForm.get('rebuildingName').value;
    payload.addressInfo.buildingNo = this.relocationForm.get('rebuildingNumber').value;
    payload.addressInfo.estateName = this.relocationForm.get('estateName').value;
    payload.addressInfo.estateStreetName = this.relocationForm.get('estateStreetName').value;
    payload.addressInfo.estateStreetNo = this.relocationForm.get('estateStreetNo').value;
    this.crudService.create(ModulesBasedApiSuffix.SALES,
      SalesModuleApiSuffixModels.CREATE_RELOCATION, payload).subscribe((response: IApplicationResponse) => {
        if (response.isSuccess && response.statusCode == 200 && response.resources) {
          this.rxjsService.setRelocation(false);
          this.rxjsService.setGlobalLoaderProperty(false);
          this.redirectToLeads(response.resources);
        }
        this.isFormSubmitted = false;
      });
  }

  onCreateReconnectionLead() {
    this.isFormSubmitted = true;
    this.validateAtleastOneFieldToBeMandatory();
    if (this.relocationForm.invalid) {
      return;
    }
    if (!this.relocationForm.value.recity ||
      !this.relocationForm.value.reprovince) {
      this.snackbarService.openSnackbar("Province Name / City Name is required..!!", ResponseMessageTypes.ERROR);
      return;
    }
    let detailObj = this.relocationForm.getRawValue();
    let location = detailObj.relocationPin;
    location = location.split(",");
    let installedArray = this.currentAddressItems.concat(this.oldAddressItems);
    let mergedArray = [];
    installedArray.forEach(element => {
      element.items.forEach(obj => {
        mergedArray.push(obj);
      });
    });
    let selectedleadCategoryId = [];
    this.relocationForm.get('leadCategoryId')?.value?.forEach(result => { selectedleadCategoryId.push(result?.id) })
    let payload: any = {
      contactInfo: {
        email: this.customerDetails.email,
        mobile1: this.customerDetails.mobile1,
        mobile1CountryCode: this.customerDetails.mobile1CountryCode,
        mobile2: this.customerDetails.mobile2,
        mobile2CountryCode: this.customerDetails.mobile2CountryCode,
        officeNo: this.customerDetails.officeNo,
        officeNoCountryCode: this.customerDetails.officeNoCountryCode,
        premisesNo: this.customerDetails.premisesNo,
        premisesNoCountryCode: this.customerDetails.premisesNoCountryCode
      },
      basicInfo: {
        customerId: this.customerId, 
        companyName: this.customerDetails.customerName?.split('(')[0],
        titleId: this.customerDetails.titleId,
        firstName: this.customerDetails.firstName, lastName: this.customerDetails.lastName,
        customerTypeId: this.customerDetails?.customerTypeName === 'Residential' ? 1 : 2
      },
      stopAndKnockRefNo: this.stopAndKnockDetails?.stopAndKnockRefNo,
      stopAndKnockId: this.stopAndKnockDetails?.stopAndKnockId,
      addressId: this.stopAndKnockDetails?.addressId,
      sourceId: this.relocationForm.getRawValue().sourceId,
      siteTypeId: this.relocationForm.getRawValue().siteTypeId,
      leadCategoryId: selectedleadCategoryId,
      modifiedUserId: this.loggedInUserData.userId,
      oldAddressId: this.relocationForm.get("currentAddressId").value
    };
    if (payload?.contactInfo?.mobile2 == "") {
      delete payload.contactInfo.mobile2CountryCode;
      delete payload.contactInfo.mobile2;
    }
    if (payload?.contactInfo?.officeNo == "") {
      delete payload.contactInfo.officeNoCountryCode;
      delete payload.contactInfo.officeNo;
    }
    if (payload?.contactInfo?.premisesNo == "") {
      delete payload.contactInfo.premisesNoCountryCode;
      delete payload.contactInfo.premisesNo;
    }
    payload.leadGroupId = LeadGroupTypes.RECONNECTION;
    payload.contactPersonTypeId = 1;
    payload.leadValidationType = "Use Existing Customer";
    payload.isRelocation = true;
    this.crudService.create(ModulesBasedApiSuffix.SALES,
      SalesModuleApiSuffixModels.CREATE_RECONNECTION, payload).subscribe((response: IApplicationResponse) => {
        if (response.isSuccess && response.statusCode == 200 && response.resources) {
          this.redirectToLeads(response.resources);
        }
        this.rxjsService.setGlobalLoaderProperty(false);
        this.isFormSubmitted = false;
      });
  }

  redirectToLeads(leadId) {
    this.rxjsService.setFromUrl("Leads List");
    this.router.navigate(['/sales/task-management/leads/lead-info/view'], { queryParams: { leadId, selectedIndex: 1 } });
  }

  checkStopAndKnockAddress(data?: any): void {
    this.crudService.get(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.STOP_AND_KNOCK_ADDRESS_CHECK,
      undefined, false, typeof data === "string" ? prepareRequiredHttpParams({ addressId: data }) : prepareRequiredHttpParams(data))
      .subscribe((response: IApplicationResponse) => {
        if (response.isSuccess && response.statusCode === 200 && response.resources) {
          this.stopAndKnockDetails = response.resources;
          this.stopAndKnockDialog = true;
          this.rxjsService.setDialogOpenProperty(true);
        }
        else if (response.isSuccess && response.statusCode === 200 && response.message.toLowerCase().includes("record not found")) {
          this.onCreateRelocationLead();
        }
        this.rxjsService.setGlobalLoaderProperty(false);
      }, (error) => {
        this.rxjsService.setGlobalLoaderProperty(false);
      });
  }

  submitStopAndKnock(): void {
    this.rxjsService.setPopupLoaderProperty(true);
    this.onCreateReconnectionLead();
  }

  ngOnDestroy() {
    this.rxjsService.setRelocation(false);
  }
}